import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectNotEmpty',
})
export class ObjectNotEmptyPipe implements PipeTransform {
  transform(data: unknown): boolean {
    if (!data || typeof data !== 'object') {
      return false;
    }

    const properties = (data as any).properties;

    if (typeof properties !== 'object' || properties === null) {
      return false;
    }

    return Object.keys(properties).length > 0;
  }
}
